// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationAutomaticUpdatesPath = 'M72.5 100c5.799 0 10.5-4.701 10.5-10.5v-79C83 4.701 78.299 0 72.5 0h-45C21.701 0 17 4.701 17 10.5v79c0 5.799 4.701 10.5 10.5 10.5h45zM24 10.5A3.5 3.5 0 0127.5 7H39l4.6 6h12.8L61 7h11.5a3.5 3.5 0 013.5 3.5v79a3.5 3.5 0 01-3.5 3.5h-45a3.5 3.5 0 01-3.5-3.5v-79zM55 84a5 5 0 11-10 0 5 5 0 0110 0zm-5-19.5a19.4 19.4 0 01-13.291-5.209L32.7 63.3 31.5 50H46l-4.293 4.293A12.2 12.2 0 0050 57.5c6.904 0 12.5-5.596 12.5-12.5h7c0 10.77-8.73 19.5-19.5 19.5zM37.5 44.523h-7a19.5 19.5 0 0132.791-14.291l4.009-4.009 1.2 13.3H54l4.293-4.292A12.2 12.2 0 0050 32.023a12.5 12.5 0 00-12.5 12.5z';
var IllustrationAutomaticUpdates = baseIllustration('IllustrationAutomaticUpdates', {
  getPath: () => IllustrationAutomaticUpdatesPath
}, 'ColoredIllustrationAutomaticUpdates');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationAutomaticUpdates;
//# sourceMappingURL=index.js.map